export default __webpack_public_path__ + "media/images/features/toyono/main_background-8eef329f5e3d8869225aed969e63f053.png";